const checkIsIntegerNumber = (value: string) => (
  !!value && /^([0-9]+)$/.test(value)
);

export default checkIsIntegerNumber;
